import { render, staticRenderFns } from "./PsEventProduct.vue?vue&type=template&id=452b1506&scoped=true&"
import script from "./PsEventProduct.vue?vue&type=script&lang=js&"
export * from "./PsEventProduct.vue?vue&type=script&lang=js&"
import style0 from "./PsEventProduct.vue?vue&type=style&index=0&id=452b1506&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452b1506",
  null
  
)

export default component.exports